<template>
    <div class="">
       <slot :rows="rows" :add="add" :remove="remove" :editField="editField">
           <template v-for="(row, n) in rows">
               <div :id="row.idRow">
                   {{ row.idRow }}
               </div>
           </template>
       </slot>
    </div>
</template>

<script>
    import { uniqueId } from 'lodash';

    export default {
        props: {
            prefix: {
                type: String,
                default: ''
            },
            defaultRows: {
                type: Array,
                default: () => []
            },
            voidRows: {
                type: [String, Number],
                default: 0
            },
            bindDefaultRow: {
                type: [String, Number, Boolean],
                default: false
            }
        },
        data() {
            return {
                rows: this.defaultRows
            };
        },
        watch: {
            defaultRows: {
                handler( defaultRows ) {
                    if( !!+this.bindDefaultRow ) {
                        this.rows = defaultRows.map((row) => {
                            return { ...row, idRow: this.prefix + (row.id || uniqueId())}
                        });
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.rows = this.defaultRows.map((row) => {
                return { ...row, idRow: this.prefix + (row.id || uniqueId())}
            });

            for( let n=0; n<( +this.voidRows || 0 ); n++ ) {
                this.add();
            }
        },
        methods: {
            add( otherData = {} ) {
                this.rows = [ ...this.rows, this.createRow(otherData) ];
            },

            editRow( nextRow = {}, prevRow = {} ) {
                const idRow = prevRow.idRow || nextRow.idRow;

                this.rows = this.rows.map(( row ) => {
                    if( row.idRow === idRow ) {
                        return nextRow;
                    }

                    return row
                });
            },
            editField( fieldName, fieldValue, prevRow ) {
                  const nextRow = { ...prevRow, [fieldName]: fieldValue };
                  this.editRow( nextRow, prevRow );
            },

            remove({ idRow }) {
                this.rows = this.rows.filter(row => row.idRow !== idRow);
            },
            createRow( otherData = {} ) {
                return {
                    idRow: this.prefix + uniqueId(),
                    ...otherData
                };
            }
        }
    }
</script>
